module.exports = __webpack_public_path__ + "static/media/UPG_RGB_Landscape_White.05853a97.svg";